module.exports = __webpack_public_path__ + "img/works_trueEtn_btm.76e876d3.jpg";